import axiosInstance from "@/services/axiosInterceptor";

export async function getUserBasicInfo() {
  try {
    const response = await axiosInstance.get(`users/basic-info`);
    const data = response?.data;

    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // If timezone exists in response and is different, update it
    if (!data?.timezone || data.timezone !== currentTimezone) {
      try {
        await axiosInstance.patch(`users/profile`, {
          timezone: currentTimezone,
        });
        data.timezone = currentTimezone;
      } catch (updateErr) {
        console.error("Failed to update timezone:", updateErr);
      }
    }

    return data;
  } catch (error) {
    localStorage.clear();
    throw error;
  }
}
